// jshint esversion: 8

export default {
  distinctive: state => state.distinctive
};
